import React, { useEffect, useMemo, useState } from 'react';

import ReturnOrderEdit from '@components/shared/return_orders/ReturnOrderEdit';
import PageHeader from '@shared/PageHeader';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';
import { useAdminReturnOrderService } from '@hooks/admin/return_orders/useAdminReturnOrderService';
import { useAdminProductService } from '@hooks/admin/products/useAdminProductService';
import { useTranslation } from 'react-i18next';

import adminInventoryAttributeDefinitionService from '@services/admin/inventoryAttributeDefinitionService';

interface InventoryTypeOption {
  id: string;
  name?: string;
  [key: string]: unknown;
}

interface InventoryAttributeDefinition {
  id?: string;
  name: string;
  [key: string]: unknown;
}

const AdminReturnOrderNew: React.FC = () => {
  const { t } = useTranslation();
  const { inventoryTypes: contextInventoryTypes, loading } = useMerchantData()!;

  const inventoryTypes = useMemo<InventoryTypeOption[]>(
    () => (contextInventoryTypes ?? []) as InventoryTypeOption[],
    [contextInventoryTypes]
  );

  const [inventoryAttributeDefinitions, setInventoryAttributeDefinitions] =
    useState<InventoryAttributeDefinition[]>([]);

  useEffect(() => {
    let cancelled = false;
    adminInventoryAttributeDefinitionService
      .fetchList()
      .then((result: { success?: boolean; data?: InventoryAttributeDefinition[] }) => {
        if (cancelled) return;
        setInventoryAttributeDefinitions(result?.data ?? []);
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        console.error('Failed to fetch inventory attribute definitions', error);
        setInventoryAttributeDefinitions([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <PageHeader
        basePath="/admin"
        items={[ 'returns', 'returns.list', { label: t('admin.menu.returns.new') } ]}
      />
      <ReturnOrderEdit
        useReturnOrderService={useAdminReturnOrderService}
        useProductService={useAdminProductService}
        role="admin"
        inventoryTypes={inventoryTypes}
        inventoryAttributeDefinitions={inventoryAttributeDefinitions}
        merchantDataLoading={Boolean(loading)}
      />
    </div>
  );
};

export default AdminReturnOrderNew;
